import { render, staticRenderFns } from "./column-date.vue?vue&type=template&id=0aed0ccc&scoped=true&"
import script from "./column-date.vue?vue&type=script&lang=js&"
export * from "./column-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aed0ccc",
  null
  
)

export default component.exports